module.exports = __webpack_public_path__ + "img/icon_mark_gray.5a0ade8d.png";